import React, { useState } from 'react';
import '../styles/styles.css';

const VideoOptionsModal = ({ visible, onConfirm, onCancel }) => {
    const [durationMinutes, setDurationMinutes] = useState('5');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        const dur = parseInt(durationMinutes, 10);
        if (isNaN(dur) || dur < 1 || dur > 30) {
            setError('Duration must be between 1 and 30 minutes');
            return;
        }
        onConfirm({ durationMinutes: dur });
    };

    if (!visible) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <h2 className="modal-title">Generate Video</h2>
                <div className="input-container">
                    <label>Video Duration (minutes)</label>
                    <input
                        type="number"
                        min="1"
                        max="30"
                        value={durationMinutes}
                        onChange={e => setDurationMinutes(e.target.value)}
                    />
                    <p className="modal-help-text">Recommended: 3�10 minutes</p>
                </div>
                {error && <p className="error-text">{error}</p>}
                <div className="modal-footer">
                    <button className="button confirm-button" onClick={handleConfirm}>Generate</button>
                    <button className="button button--ghost" onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default VideoOptionsModal;